// import readCookie from './readCookie';

var downloadToolkits = (function () {

  var setDownloadToolkits = function () {
    $('.c-show-download-toolkits-form').click(function(){
      $(this).parent().addClass('u-hidden');
      $(this).parents('.c-download-toolkits__container')
        .find('.c-download-toolkits--form').removeClass('u-hidden');
      $(this).parents('.c-download-toolkits__container')
        .find('.c-download-toolkits--subtext').addClass('u-hidden');
    });
    // $('.c-show-download-toolkits-form').click(function(){
    //   var toolkitsId = $(this).attr('data-toolkit-id');
    //   var $currentBth = $(this);
    //   var locationOrigin = window.location.origin;
    //   if(readCookie('gf_tk_form_email')){
    //     $currentBth.addClass('submitting');
    //     $.ajax({
    //       method: 'POST',
    //       crossDomain: true,
    //       dataType: 'jsonp',
    //       url: locationOrigin + "/api/returnpointdata/toolkitCheck/",
    //       data:{
    //         "toolkitid": toolkitsId
    //       },
    //       success: function(response){
    //         $currentBth.removeClass('submitting');
    //         $currentBth.parents('.c-download-toolkits__container').find('.c-download-toolkits--copy').addClass('u-hidden');
    //         if(response.success == true){
    //           $currentBth.parent().addClass('u-hidden');
    //           var toolkitData = response.data;
    //           function attachments(attachmentsArr){
    //               var attachmentsList = "";
    //               for (var a =0; a< attachmentsArr.length; a++){
    //                   // attachmentsList += "<a class='c-button c-button--primary-button' href='"+ attachmentsArr[a].link +"'><span>"+ attachmentsArr[a].title +"</span></a>";
    //                   attachmentsList += attachmentsArr[a];
    //               }
    //               return attachmentsList;
    //           }
    //           $currentBth.parents('.c-download-toolkits__container')
    //               .find('.c-download-toolkits--success-wrapper').html(
    //                 "<div class='c-download-toolkits--success'>\n\
    //                     <h3>" + toolkitData.title + "</h3>\n\
    //                     <p>" + toolkitData.description + "</p>\n\
    //                     <p class='c-italic-font'>" + toolkitData.terms + "</p> \n\
    //                     " + attachments(toolkitData.attachments) + "</div>"
    //           );
    //         }else{
    //           $currentBth.parents('.c-download-toolkits__container').find('.c-download-toolkits--success-wrapper').html(
    //             "<div class='c-download-toolkits--success'>\n\
    //                 <p>" + response.message + "</p></div>"
    //           );
    //         }
    //       },
    //       error: function(response){
    //       }
    //     });
        
    //   }else{
    //     $(this).parent().addClass('u-hidden');
    //     $(this).parents('.c-download-toolkits__container')
    //       .find('.c-download-toolkits--form').removeClass('u-hidden');
    //   }
    // });
  };

  var init = function () {
    setDownloadToolkits();
  };

  return {
    init: init
  };
})();

export default downloadToolkits;


// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/downloadToolkits.js